// extracted by mini-css-extract-plugin
export default {"container":"disclaimer_container__4pOeD","img":"disclaimer_img__g5z0Q"};